export const licenses: Record<string, { label: string; shortLabel: string; href: string | null }> = {
  'all-rights-reserved': {
    label: 'All Rights Reserved',
    shortLabel: 'All Rights Reserved',
    href: null,
  },
  by: {
    label: 'CC BY 4.0 (Attribution)',
    shortLabel: 'CC BY 4.0',
    href: 'https://creativecommons.org/licenses/by/4.0/',
  },
  'by-sa': {
    label: 'CC BY-SA 4.0 (Attribution-ShareAlike)',
    shortLabel: 'CC BY-SA 4.0',
    href: 'https://creativecommons.org/licenses/by-sa/4.0/',
  },
  'by-nd': {
    label: 'CC BY-ND 4.0 (Attribution-NoDerivs)',
    shortLabel: 'CC BY-ND 4.0',
    href: 'https://creativecommons.org/licenses/by-nd/4.0/',
  },
  'by-nc': {
    label: 'CC BY-NC 4.0 (Attribution-NonCommercial)',
    shortLabel: 'CC BY-NC 4.0',
    href: 'https://creativecommons.org/licenses/by-nc/4.0/',
  },
  'by-nc-sa': {
    label: 'CC BY-NC-SA 4.0 (Attribution-NonCommercial-ShareAlike)',
    shortLabel: 'CC BY-NC-SA 4.0',
    href: 'https://creativecommons.org/licenses/by-nc-sa/4.0/',
  },
  'by-nc-nd': {
    label: 'CC BY-NC-ND 4.0 (Attribution-NonCommercial-NoDerivs)',
    shortLabel: 'CC BY-NC-ND 4.0',
    href: 'https://creativecommons.org/licenses/by-nc-nd/4.0/',
  },
  'cc-zero': {
    label: 'CC0 1.0 (No Rights Reserved)',
    shortLabel: 'CC0 1.0',
    href: 'https://creativecommons.org/publicdomain/zero/1.0/',
  },
};
